<nav class="asset-navbar" aria-label="Listing toolbar">
  <div class="asset-navbar__track">
    <div class="asset-navbar__search">
      <div class="asset-navbar__search-field">
        <img src="/icons/search.svg" alt="" class="asset-navbar__search-icon shrink-0" width="18" height="18" />
        <input
          type="search"
          class="asset-navbar__search-input"
          [placeholder]="searchPlaceholder"
          [value]="searchQuery"
          (input)="onSearchInput($event)"
          aria-label="Search"
        />
      </div>
    </div>

    <div class="asset-navbar__end">
      <div class="asset-navbar__actions flex flex-wrap items-center gap-2">
      <button
        type="button"
        class="asset-navbar__btn asset-navbar__btn--lock-host"
        [class.asset-navbar__btn--active]="isLoggedIn && bookmarksActive"
        [class.asset-navbar__btn--locked]="!isLoggedIn"
        [attr.aria-pressed]="isLoggedIn && bookmarksActive"
        [attr.aria-disabled]="!isLoggedIn"
        (click)="bookmarksClick.emit()"
      >
        @if (!isLoggedIn) {
          <span class="asset-navbar__lock-badge" aria-hidden="true">
            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        }
        @if (isLoggedIn && bookmarksActive) {
          <img src="/icons/bookmark-filled.svg" alt="" width="16" height="16" class="shrink-0" />
        } @else {
          <img src="/icons/bookmark.svg" alt="" width="16" height="16" class="shrink-0" />
        }
        Bookmarks
      </button>
      <button
        type="button"
        class="asset-navbar__btn asset-navbar__btn--lock-host"
        [class.asset-navbar__btn--active]="isLoggedIn && likeActive"
        [class.asset-navbar__btn--locked]="!isLoggedIn"
        [attr.aria-pressed]="isLoggedIn && likeActive"
        [attr.aria-disabled]="!isLoggedIn"
        (click)="likesClick.emit()"
      >
        @if (!isLoggedIn) {
          <span class="asset-navbar__lock-badge" aria-hidden="true">
            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        }
        @if (isLoggedIn && likeActive) {
          <img src="/icons/thumbs-up-filled.svg" alt="" width="14" height="14" class="shrink-0" />
        } @else {
          <img src="/icons/thumbs-up.svg" alt="" width="14" height="14" class="shrink-0" />
        }
        Likes
      </button>
      </div>

      <p class="asset-navbar__range m-0 whitespace-nowrap">
        Showing {{ showingFrom }}–{{ showingTo }} of {{ totalCount }}
      </p>

      <div class="asset-navbar__sort-wrap shrink-0">
      <span class="asset-navbar__visually-hidden" id="asset-navbar-sort-label">Sort results</span>
      <button
        #sortTrigger
        type="button"
        id="asset-navbar-sort"
        class="asset-navbar__sort-trigger"
        (click)="toggleSortMenu($event)"
        [attr.aria-expanded]="sortMenuOpen()"
        aria-haspopup="listbox"
        aria-controls="asset-navbar-sort-listbox"
        aria-labelledby="asset-navbar-sort-label"
      >
        <span class="asset-navbar__sort-trigger-text">Sort by: {{ sortLabel() }}</span>
        <img
          src="/icons/chevron-down-black.svg"
          alt=""
          class="asset-navbar__sort-chevron"
          [class.asset-navbar__sort-chevron--open]="sortMenuOpen()"
          width="16"
          height="16"
        />
      </button>
      </div>

      <div class="asset-navbar__view-toggle shrink-0" role="group" aria-label="View mode">
      <button
        type="button"
        class="asset-navbar__view-btn"
        [class.asset-navbar__view-btn--active]="viewMode === 'grid'"
        (click)="setViewMode('grid')"
        [attr.aria-pressed]="viewMode === 'grid' ? 'true' : 'false'"
        aria-label="Grid view"
      >
        <img src="/icons/box.svg" alt="" width="18" height="18" />
      </button>
      <button
        type="button"
        class="asset-navbar__view-btn"
        [class.asset-navbar__view-btn--active]="viewMode === 'list'"
        (click)="setViewMode('list')"
        [attr.aria-pressed]="viewMode === 'list' ? 'true' : 'false'"
        aria-label="List view"
      >
        <img src="/icons/list-view.svg" alt="" width="18" height="18" />
      </button>
      </div>
    </div>
  </div>

  @if (sortMenuOpen()) {
    <ul
      #sortList
      id="asset-navbar-sort-listbox"
      class="asset-navbar__sort-list"
      role="listbox"
      aria-labelledby="asset-navbar-sort-label"
      [style.top]="sortListLayout()?.top"
      [style.left]="sortListLayout()?.left"
      [style.width]="sortListLayout()?.width"
    >
      @for (def of sortDefinitions; track def.id) {
        <li role="presentation">
          <button
            type="button"
            class="asset-navbar__sort-item"
            [class.asset-navbar__sort-item--selected]="isSelected(def.id)"
            role="option"
            [attr.aria-selected]="isSelected(def.id)"
            (click)="selectSortOption(def.id, $event)"
          >
            <span class="asset-navbar__sort-check" aria-hidden="true">
              @if (isSelected(def.id)) {
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            </span>
            <span class="asset-navbar__sort-item-label">{{ def.label }}</span>
          </button>
        </li>
      }
    </ul>
  }
</nav>
